import { render, staticRenderFns } from "./sysModuleCreate.vue?vue&type=template&id=609ba384&scoped=true&"
import script from "./sysModuleCreate.vue?vue&type=script&lang=js&"
export * from "./sysModuleCreate.vue?vue&type=script&lang=js&"
import style0 from "./sysModuleCreate.vue?vue&type=style&index=0&id=609ba384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609ba384",
  null
  
)

export default component.exports